import {
  Collapse,
  Divider,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { MATCH_FLOWS_TABLE_HEADER_COLUMNS } from '../consts';
import STRING_KEYS from '../../../../../language/keys';
import { JsonRenderer } from '../../../../../components/JsonRenderer/json-renderer.component';
import { style } from './style';

type MatchFlowLogsCollapseItemProps = {
  isOpenRow: boolean,
  matchFlowId: string;
  inputParameters: InputParameters,
  outputParameters: Record<string, unknown>,
}

export const MatchFlowLogsCollapseItem = ({
  isOpenRow,
  matchFlowId,
  inputParameters,
  outputParameters,
}:MatchFlowLogsCollapseItemProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <TableRow sx={ style.tableRow.sx(isOpenRow)  }>
      <TableCell colSpan={ MATCH_FLOWS_TABLE_HEADER_COLUMNS } sx={ style.tableCell.sx }>
        <Collapse in={ isOpenRow } sx={ style.Collapse.sx }>
          <div style={ style.MatchFlowId }>
            {translate(STRING_KEYS.MATCH_FLOW_ID)}: { matchFlowId }
          </div>
          <div>
            <Box sx={ style.boxContainer.sx }>
              <Typography variant="h6" sx={ style.TypographyH6.sx }>
                {translate(STRING_KEYS.INPUT_PARAMETERS)}
              </Typography>
              <Box sx={ style.box.sx }>
                <Typography variant="subtitle2" sx={ style.Typography.sx }>
                  <JsonRenderer src={ inputParameters } collapsed />
                </Typography>
              </Box>
            </Box>
            <Divider sx={ style.divider.sx } />
            <Box sx={ style.boxContainer.sx }>
              <Typography variant="h6" sx={ style.TypographyH6.sx }>
                {translate(STRING_KEYS.ENGINE_PARAMETERS)}
              </Typography>
              <Box sx={ style.box.sx }>
                <Typography variant="subtitle2" sx={ style.Typography.sx }>
                  <JsonRenderer src={ outputParameters } collapsed />
                </Typography>
              </Box>
            </Box>
          </div>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
